<div class="fixed inset-0 z-[1000] bg-black/80 flex items-center justify-center" (click)="closed.emit()">
  <button
    type="button"
    class="absolute top-xl right-xl flex p-sm text-white/80 hover:text-white"
    (click)="closed.emit()"
    aria-label="Close image"
  >
    <svg-icon key="close" class="text-lg!"></svg-icon>
  </button>

  @if (images().length > 1) {
    <button
      type="button"
      class="absolute left-xl flex p-sm rounded-full bg-black/40 text-white/80 hover:text-white"
      (click)="move(-1, $event)"
      aria-label="Previous image"
    >
      <svg-icon key="arrow-left" class="text-lg!"></svg-icon>
    </button>
    <button
      type="button"
      class="absolute right-xl flex p-sm rounded-full bg-black/40 text-white/80 hover:text-white"
      (click)="move(1, $event)"
      aria-label="Next image"
    >
      <svg-icon key="arrow-right" class="text-lg!"></svg-icon>
    </button>
  }

  @let caption = captions()[index()];
  @if (caption || images().length > 1) {
    <div
      class="absolute bottom-xl left-1/2 -translate-x-1/2 max-w-[80vw] flex flex-col items-center gap-xs text-center text-sm leading-sm text-white/80"
      (click)="$event.stopPropagation()"
    >
      @if (caption) {
        <div class="text-base leading-base font-semibold text-white">{{ caption }}</div>
      }
      @if (images().length > 1) {
        <div>{{ index() + 1 }} / {{ images().length }}</div>
      }
    </div>
  }

  <img
    class="max-w-[90vw] max-h-[85vh] object-contain rounded-base"
    [src]="images()[index()]"
    alt="Image preview"
    (click)="$event.stopPropagation()"
  />
</div>
